/**
 * Façade do sistema de conquistas — preserva a API original `checkAchievements()`.
 * Internamente combina leitura (fetchAchievementsList + meetsRequirement + fetchUserMetrics)
 * e escrita (useGrantAchievement).
 */
import { useCallback } from 'react';
import { useAuth } from '@/hooks/useAuth';
import {
  fetchAchievementsList,
  fetchUserMetrics,
  meetsRequirement,
} from '@/hooks/achievements/useAchievementsList';
import { useGrantAchievement } from '@/hooks/achievements/useGrantAchievement';
import { handleSupabaseError } from '@/lib/errors/handleSupabaseError';

export type { Achievement, UserMetrics, Rarity } from '@/hooks/achievements/types';

export function useAchievements() {
  const { user } = useAuth();
  const { grantAchievement } = useGrantAchievement();

  const checkAchievements = useCallback(async () => {
    if (!user) return;
    try {
      const { notUnlocked } = await fetchAchievementsList(user.id);
      if (notUnlocked.length === 0) return;
      const metrics = await fetchUserMetrics(user.id);
      for (const achievement of notUnlocked) {
        if (meetsRequirement(achievement, metrics)) {
          await grantAchievement(user.id, achievement);
        }
      }
    } catch (error) {
      handleSupabaseError(error, 'Erro ao verificar conquistas.', { silent: true, context: { hook: 'useAchievements.check' } });
    }
  }, [user, grantAchievement]);

  return { checkAchievements };
}
